import { render, staticRenderFns } from "./RecipeInfo.vue?vue&type=template&id=0ea0283a"
import script from "./RecipeInfo.vue?vue&type=script&lang=js"
export * from "./RecipeInfo.vue?vue&type=script&lang=js"
import style0 from "./RecipeInfo.vue?vue&type=style&index=0&id=0ea0283a&prod&lang=scss"
import style1 from "./RecipeInfo.vue?vue&type=style&index=1&id=0ea0283a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports